import React, { useState } from "react";
import { Tabs, Typography } from "antd";
import {
  KeyOutlined,
  BookOutlined,
  HistoryOutlined,
} from "@ant-design/icons";

import ApiKeys from "./ApiKeys";
import ApiDocumentation from "./ApiDocumentation";
import ApiRequestHistory from "./ApiRequestHistory";

import "./apiIntegration.css";

const { Title, Text } = Typography;

const ApiIntegration = ({ users }) => {
  const [activeTab, setActiveTab] = useState("keys");

  const items = [
    {
      key: "keys",
      label: (
        <span>
          <KeyOutlined />
          API Keys
        </span>
      ),
      children: <ApiKeys users={users} />,
    },
    {
      key: "documentation",
      label: (
        <span>
          <BookOutlined />
          Documentation
        </span>
      ),
      children: <ApiDocumentation />,
    },
    {
      key: "history",
      label: (
        <span>
          <HistoryOutlined />
          Request History
        </span>
      ),
      children: <ApiRequestHistory />,
    },
  ];

  return (
    <div className="crm-api-integration">
      <div className="crm-api-page-header">
        <Title level={4} style={{ marginBottom: 4 }}>
          Website / Public API Integration
        </Title>

        <Text type="secondary">
          Connect websites and external applications securely with your CRM.
        </Text>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ marginTop: 20 }}
      />
    </div>
  );
};

export default ApiIntegration;